module.exports = __webpack_public_path__ + "static/img/femiUk.53f95e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/femiUk.jpg
// module id = ysVE
// module chunks = 1